import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../utils/i18n';
import TextFieldInlineEdit from './TextFieldInlineEdit';
import {issueAttributesType} from '../../constants/proptype-validation';
import {ISSUE_ATTRIBUTE_NAMES} from '../../constants/issue-attribute-names';
import IssueFieldInlineEdit from './IssueFieldInlineEdit';
import {validateLocationDetails} from '../../utils/validation-helpers';

const LocationDescriptionInlineEdit = ({issue, className, styleType, isRequired, ...rest}) => (
  <TextFieldInlineEdit
    issue={issue}
    className={className}
    label={i18n.t('new.locationDetails')}
    placeholder={i18n.t('unspecifiedValue')}
    attributeName={ISSUE_ATTRIBUTE_NAMES.LOCATION_DETAILS}
    styleType={styleType}
    isRequired={isRequired}
    inputValidator={validateLocationDetails}
    data-testid={rest['data-testid']}
  />
);

LocationDescriptionInlineEdit.displayName = 'LocationDescriptionInlineEdit';

LocationDescriptionInlineEdit.propTypes = {
  issue: issueAttributesType,
  className: PropTypes.string,
  styleType: PropTypes.oneOf(Object.values(IssueFieldInlineEdit.StyleTypes)),
  isRequired: PropTypes.bool
};

export default LocationDescriptionInlineEdit;
